module.exports = __webpack_public_path__ + "img/cost-impact.009bb82f.svg";